import React from 'react';
import { graphql } from 'gatsby';
import SEO from '../components/SEO';
import Helmet from 'react-helmet';
import Layout from '../layouts/index';


const Page = ({ data }) => {
  const { title } = data.markdownRemark.frontmatter;
  const { seotitle } = data.markdownRemark.frontmatter;
  const { description } = data.markdownRemark.frontmatter;
  const { pageclass } = data.markdownRemark.frontmatter;
  const { metaimg } = data.markdownRemark.frontmatter;
  const metaImgUrl = `https://www.charthop.com${metaimg}`;
  const { html } = data.markdownRemark;
  return (
    <Layout  bodyClass={pageclass}>
      <SEO title={seotitle} />
      <Helmet>
        <meta
          name="description"
          content={description}
        />
        <meta property="og:title" content={seotitle} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={metaImgUrl} />
        <meta property="og:type" content="website" />
        {/* Twitter Card tags */}
        <meta name="twitter:title" content={seotitle} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={metaImgUrl} />
        <meta name="twitter:card" content="summary_large_image" />

      </Helmet>
      <div className="container pt-4 pb-4 pt-md-6  pd-md-6">
        <div className="row justify-content-start">
          <div className="col-12 col-md-8">
            <div className="page-single">
              <h1 className="title">{title}</h1>
              <div className="content" dangerouslySetInnerHTML={{ __html: html }} />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        path
        pageclass
        seotitle
        description
        metaimg
      }
      html
    }
  }
`;

export default Page;
